import React, { forwardRef } from "react";
import { Control } from "react-hook-form";

import ToggleBase, { ToggleProps } from "@/components/ui/Form/Toggle/ToggleBase";
import ToggleControlled from "@/components/ui/Form/Toggle/ToggleControlled";

interface DynamicInputProps extends ToggleProps {
  control?: Control<any>;
}

const Toggle = forwardRef<HTMLInputElement, DynamicInputProps>((args, ref) => {
  return <>{args?.control ? <ToggleControlled control={args.control} {...args} /> : <ToggleBase {...args} />}</>;
});
Toggle.displayName = "Toggle";
export default Toggle;
